/* eslint-disable */
import axios from "@/axios";
import store from "@/store";

export function getObjectMetadata({ objectType, objectId, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.get(`/metadata/${objectType}/${objectId}`, { headers, signal });
}

export function updateObjectMetadata({ objectType, objectId, payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.put(`/metadata/${objectType}/${objectId}`, payload, { headers });
}

export function createObjectMetadata({ objectType, objectId, payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.post(`/metadata/${objectType}/${objectId}`, payload, { headers });
}